import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dots from 'react-carousel-dots';
import { getTestimonials } from './actions';
import { Col } from 'react-bootstrap';

import leftArrow from '../../../resources/ExperienceCards/Left Arrow.png';
import rightArrow from '../../../resources/ExperienceCards/Right Arrow.png';

class Testimonials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTestimonialIndex: 0,
      title: this.props.title || 'What customers are saying',
    };
  }

  componentDidMount() {
    this.props.getTestimonials();
  }

  setPrevTestimonial = () => {
    if (this.props.testimonials.length) {
      let currentTestimonialIndex = this.state.currentTestimonialIndex - 1;
      currentTestimonialIndex =
        currentTestimonialIndex < 0 ? this.props.testimonials.length - 1 : currentTestimonialIndex;
      this.setState({ currentTestimonialIndex });
    }
  };

  setNextTestimonial = () => {
    if (this.props.testimonials.length) {
      let currentTestimonialIndex = this.state.currentTestimonialIndex + 1;
      currentTestimonialIndex = currentTestimonialIndex >= this.props.testimonials.length ? 0 : currentTestimonialIndex;
      this.setState({ currentTestimonialIndex });
    }
  };

  render() {
    if (!this.props.testimonials.length) {
      return null;
    }

    let currentTestimonialIndex = this.state.currentTestimonialIndex;
    let currentTestimonialText = '';
    let currentTestimonialOwner = '';
    let currentTestimonialRelationship = '';

    if (this.props.testimonials.length) {
      currentTestimonialText = this.props.testimonials[currentTestimonialIndex].text;
      currentTestimonialOwner = this.props.testimonials[currentTestimonialIndex].owner;
      currentTestimonialRelationship = this.props.testimonials[currentTestimonialIndex].relationship;
    }

    return (
      <div className="testimonialsContainer">
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="title secondaryHeaderFonts">{this.state.title}</div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="carousal">
            <Col
              xs={2}
              sm={2}
              md={2}
              lg={2}
              className="arrow"
              style={{ backgroundImage: 'url(' + leftArrow + ')' }}
              onClick={(e) => this.setPrevTestimonial()}
            />
            <Col xs={8} sm={8} md={8} lg={8}>
              <div className="testimonial">
                <div className="testimonialText bodyTextFonts">"{currentTestimonialText}"</div>
                {currentTestimonialOwner && (
                  <div className="currentTestimonialSignature">
                    <div className="testimonialOwner">{currentTestimonialOwner}</div>
                    {currentTestimonialRelationship && (
                      <div className="testimonialRelationship">{currentTestimonialRelationship}</div>
                    )}
                  </div>
                )}
              </div>
            </Col>
            <Col
              xs={2}
              sm={2}
              md={2}
              lg={2}
              className="arrow"
              style={{ backgroundImage: 'url(' + rightArrow + ')' }}
              onClick={(e) => this.setNextTestimonial()}
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Dots className="carouselDots" length={this.props.testimonials.length} active={currentTestimonialIndex} />
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  testimonials: state.testimonials,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getTestimonials: getTestimonials }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Testimonials);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/Testimonials/Testimonials.js